import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

//UI
import CorporateContactDashboard from "./CorporateContactDashboard";

//processing
import {
  ONBOARDING_CUSTOMER_STATUS,
  RECORD_OPERATIONS,
  ONBOARDING_USER_TYPE,
} from "../../../utils/onboarding-helper";
import { useGetCustomer } from "../../../hooks/Onboarding/onboarding.hooks";
import { useSearchOnboardingUser } from "../../../hooks/Onboarding/onboarding-users.hooks";

const CorporateContactHandler = (props) => {
  const { userName } = props;

  const history = useHistory();

  //get corp user details
  const searchParams = new URLSearchParams({
    email: userName,
    type: ONBOARDING_USER_TYPE.CORPORATE_CONTACT,
  });

  const { isSuccess: isSuccessCorpContact, data: apiCorpContactData } =
    useSearchOnboardingUser(searchParams);

  const { isSuccess: isSuccessCustomer, data: apiCustomerData } =
    useGetCustomer(apiCorpContactData?.customer_id, {
      enabled: isSuccessCorpContact,
    });

  useEffect(() => {
    if (apiCustomerData?.status === ONBOARDING_CUSTOMER_STATUS.PENDING) {
      history.push(`/onboarding/customers/${apiCustomerData._id}/approve`);
    }
  }, [apiCustomerData]);

  if (isSuccessCorpContact && isSuccessCustomer) {
    if (
      apiCustomerData.status === ONBOARDING_CUSTOMER_STATUS.CUSTOMER_CREATED
    ) {
      return (
        <CorporateContactDashboard
          customer={apiCustomerData}
          corporateContact={apiCorpContactData}
        />
      );
    }
    //  else if (
    //   apiCustomerData.status === ONBOARDING_CUSTOMER_STATUS.CUSTOMER_DEACTVATED
    // ) {
    //   return "Deactivated";
    // }
  }
  return null;
};

export default CorporateContactHandler;
